"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _textField = _interopRequireDefault(require("../text-field"));

var _Calendar = require("./Calendar");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DatePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this$props$flex, _this$props$date, _this$props$startDate, _this$props$endDate;

    var _this;

    (0, _classCallCheck2.default)(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "now", new Date());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      flex: (_this$props$flex = _this.props.flex) !== null && _this$props$flex !== void 0 ? _this$props$flex : undefined,
      selectedDate: (_this$props$date = _this.props.date) !== null && _this$props$date !== void 0 ? _this$props$date : undefined,
      selectedStartDate: (_this$props$startDate = _this.props.startDate) !== null && _this$props$startDate !== void 0 ? _this$props$startDate : undefined,
      selectedEndDate: (_this$props$endDate = _this.props.endDate) !== null && _this$props$endDate !== void 0 ? _this$props$endDate : undefined,
      visibleMonth: _this.now.getMonth(),
      visibleYear: _this.now.getFullYear()
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChangeMonth", function (offset) {
      var _this$state = _this.state,
          visibleMonth = _this$state.visibleMonth,
          visibleYear = _this$state.visibleYear;
      var newMonth = visibleMonth + offset;
      var newYear = visibleYear;

      switch (newMonth) {
        case -1:
          newMonth = 11;
          newYear--;
          break;

        case 12:
          newMonth = 0;
          newYear++;
          break;
      }

      _this.setState({
        visibleMonth: newMonth,
        visibleYear: newYear
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTextFieldChange", function (value) {
      var dateStrings = value.includes(' to ') ? value.split(' to ') : value.split(' - ');

      if (dateStrings.length === 1 && !isNaN(Date.parse(dateStrings[0]))) {
        var newStartDate = new Date(dateStrings[0]);

        _this.setDateRange(newStartDate, undefined);

        return;
      }

      if (dateStrings.length === 2 && !isNaN(Date.parse(dateStrings[0])) && !isNaN(Date.parse(dateStrings[1]))) {
        var _newStartDate = new Date(dateStrings[0]);

        var newEndDate = new Date(dateStrings[1]);
        newEndDate.setHours(23, 59, 59, 999);

        _this.setDateRange(_newStartDate, newEndDate);

        return;
      }

      _this.setDateRange(undefined, undefined);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSelectDate", function (day) {
      var _this$state2 = _this.state,
          visibleMonth = _this$state2.visibleMonth,
          visibleYear = _this$state2.visibleYear;
      var selectedDate = new Date(visibleYear, visibleMonth, day);

      if (_this.props.dateRange) {
        _this.selectDateRangeDate(selectedDate);
      } else {
        _this.selectSingleDate(selectedDate);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(DatePicker, [{
    key: "setDateRange",
    value: function setDateRange(start, end) {
      var _this$props$onDateRan, _this$props;

      this.setState({
        selectedStartDate: start,
        selectedEndDate: end
      });
      (_this$props$onDateRan = (_this$props = this.props).onDateRangeChange) === null || _this$props$onDateRan === void 0 ? void 0 : _this$props$onDateRan.call(_this$props, {
        from: start,
        to: end
      });
    }
  }, {
    key: "selectSingleDate",
    value: function selectSingleDate(selectedDate) {
      var _this$props$onDateCha, _this$props2;

      this.setState({
        selectedDate: selectedDate
      });
      (_this$props$onDateCha = (_this$props2 = this.props).onDateChange) === null || _this$props$onDateCha === void 0 ? void 0 : _this$props$onDateCha.call(_this$props2, selectedDate);
    }
  }, {
    key: "selectDateRangeDate",
    value: function selectDateRangeDate(selectedDate) {
      var _this$state3 = this.state,
          selectedStartDate = _this$state3.selectedStartDate,
          selectedEndDate = _this$state3.selectedEndDate;
      var isStartDate = Boolean(selectedStartDate) === Boolean(selectedEndDate) || selectedDate.getTime() <= Number(selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getTime());

      if (isStartDate) {
        this.setDateRange(selectedDate, undefined);
      } else {
        selectedDate.setHours(23, 59, 59, 999);
        this.setDateRange(selectedStartDate, selectedDate);
      }
    }
  }, {
    key: "getFormattedInputValue",
    value: function getFormattedInputValue() {
      var _this$state4 = this.state,
          selectedStartDate = _this$state4.selectedStartDate,
          selectedEndDate = _this$state4.selectedEndDate;

      if (!selectedStartDate) {
        return '';
      }

      if (!selectedEndDate) {
        return DatePicker.formatDate(selectedStartDate);
      }

      return "".concat(DatePicker.formatDate(selectedStartDate), " to ").concat(DatePicker.formatDate(selectedEndDate));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          dateRange = _this$props3.dateRange,
          placeholder = _this$props3.placeholder,
          disableOutOfBoundsDates = _this$props3.disableOutOfBoundsDates,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate;
      var _this$state5 = this.state,
          selectedDate = _this$state5.selectedDate,
          selectedStartDate = _this$state5.selectedStartDate,
          selectedEndDate = _this$state5.selectedEndDate,
          visibleMonth = _this$state5.visibleMonth,
          visibleYear = _this$state5.visibleYear,
          flex = _this$state5.flex;
      return (0, _preact.h)("div", {
        className: "o-date-picker".concat(flex ? ' o-date-picker-flex' : '')
      }, dateRange && (0, _preact.h)(_textField.default, {
        id: "date-picker",
        ariaLabel: "date-picker",
        name: "date-picker",
        isControl: true,
        defaultValue: selectedStartDate ? this.getFormattedInputValue() : undefined,
        updateInputValue: this.getFormattedInputValue(),
        onChange: this.handleTextFieldChange,
        placeholder: placeholder
      }), (0, _preact.h)("div", {
        className: "m-calendar-wrapper".concat(flex ? ' m-calendar-wrapper-flex' : '')
      }, (0, _preact.h)(_Calendar.Calendar, {
        month: visibleMonth,
        year: visibleYear,
        selectedDate: selectedDate,
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate,
        today: this.now,
        disableOutOfBoundsDates: disableOutOfBoundsDates,
        minDate: minDate,
        maxDate: maxDate,
        onChangeMonth: this.handleChangeMonth,
        onSelectDate: this.handleSelectDate
      })));
    }
  }], [{
    key: "formatDate",
    value: function formatDate(date) {
      var month = date.toLocaleString('en-GB', {
        month: 'short'
      });
      var day = date.getDate();
      var year = date.getFullYear();
      return "".concat(month, " ").concat(day, ", ").concat(year);
    }
  }]);
  return DatePicker;
}(_preact.Component);

var _default = DatePicker;
exports.default = _default;